import { FC, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AddUpdatedigitalCardDrawer } from './components/AddUpdatedigitalCardDrawer';
import DragDropDataGrid from './components/DragDropDataGrid';
import { SCUIContent } from '../../atomic/organisms';
import { Box, Paper, Typography } from '@mui/material';
import { SCUIButton } from '../../atomic/atoms';
import { SCUIGeneralDrawer } from '../../atomic/molecules';
import { DCA, dcaCls } from './digitalCard.classes';

export const DigitalCard: FC<any> = () => {
    const [open, setOpen] = useState({ right: false });
    const { t } = useTranslation();

    const onDrawerOpen = useCallback(() => {
        setOpen((prevOpen) => ({ ...prevOpen, right: true }));
    }, []);

    const onDrawerClose = useCallback(() => {
        setOpen((prevOpen) => ({ ...prevOpen, right: false }));
    }, []);

    const [selectedDigitalCard, setSelectedDigitalCard] = useState<any>();
    const [refresh, setRefresh] = useState(false);

    const refreshDigitalCard = () => {
        setRefresh((prevLoading) => !prevLoading);
    };

    const handleOpenDrawer = () => {
        setSelectedDigitalCard([]);
        onDrawerOpen();
    };

    return (
        <SCUIContent>
            <SCUIGeneralDrawer
                open={open['right']}
                anchor="right"
                width={'540px'}
                onClose={(_: any, reason: any) => {
                    if (reason === 'backdropClick') {
                        setOpen({ ...open, right: false });
                    }
                }}
            >
                <AddUpdatedigitalCardDrawer
                    selectedRow={selectedDigitalCard}
                    refresh={refreshDigitalCard}
                    onClose={onDrawerClose}
                />
            </SCUIGeneralDrawer>

            {/* Page header */}
            <Box className={DCA.pageHeader} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3 }}>
                <Typography sx={{ fontSize: '1.5rem !important', fontWeight: 700 }} className={dcaCls('headtxt', DCA.pageTitle)}>
                    {t('digitalGiftCard.title')}
                </Typography>
                <SCUIButton
                    className={DCA.inputButtonAdd}
                    text={t('digitalGiftCard.addDigitalGiftCard')}
                    type="primary"
                    sizeType="fixed"
                    size={'m'}
                    onClick={handleOpenDrawer}
                />
            </Box>

            {/* Table card */}
            <Paper
                className={DCA.tablePaper}
                elevation={0}
                sx={{
                    border: '1px solid',
                    borderColor: 'divider',
                    borderRadius: 2,
                    boxShadow: '0 2px 12px rgba(0,0,0,0.09)',
                    overflow: 'hidden',
                }}
            >
                <DragDropDataGrid
                    selectedDigitalCard={selectedDigitalCard}
                    setSelectedDigitalCard={setSelectedDigitalCard}
                    onDrawerOpen={onDrawerOpen}
                    refresh={refresh}
                />
            </Paper>
        </SCUIContent>
    );
};
